import { RUPEE_SYMBOL } from "../../../../Poker/data/Constants";
import styles from "./A23DealMakingICMPayout.module.css";
import gameAssets from '@themed-assets';
import usePlayerSeat from "@/src/hooks/data/usePlayerSeat";
import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";
import useTourneyDealMaking from "@/src/hooks/utils/useTourneyDealMaking";
import { checkToDisplayValueInCr, checkToDisplayValueInL, parseDecimalValuesOfNumber } from "../../../../Common/utils/GameUtils";
import { useDealICMObject } from "@/src/hooks/data/useGameTable";


export default function A23DealMakingICMPayout(props) {
    const { tempTableId } = props;
    const dealICMObject = useDealICMObject(tempTableId);
    const { dealICMRunTime, dealICMData, dealICMVoted, pendingAck } = dealICMObject || {};
    const { userName } = usePlayerDetails();

    const { onAcceptButtonClick, onRejectButtonClick  } = useTourneyDealMaking(tempTableId);

    // const dealtimerEndCallBack = () => {
    //     dispatch(closeDealMakingICMPayoutPopup({
    //         tempTableId : tempTableId
    //     }))
    // }

    const renderPlayerDetails = (playerName, playerDetails, index) => {
        const { actualPayout, icmPayout, chipStack, playerICMStatus } = playerDetails || {};
        return (
            <div key={`${playerName}-${index}`} id={`player-${index}`} className={styles.playerDetailsWrapper}>
                <div style={{ alignItems: "flex-start" }} className={styles.playerDataWrapper}>
                    <div className={styles.playerNameWrapper}>
                        <span style={{color : playerName === userName ? "#eabf69" : "#fffdea"}}>
                            {playerName}
                        </span>
                        {playerICMStatus === true ?
                            <img className={styles.dealStatusIcon} src={gameAssets.dealAccepted}></img>
                            : playerICMStatus === false ?
                                <img className={styles.dealStatusIcon} src={gameAssets.dealRejected}></img> :
                                <div className={styles.dealPendingWrapper}>
                                    <span className={`${styles.dealPendingDot} ${styles.delay1}`}>•</span>
                                    <span className={`${styles.dealPendingDot} ${styles.delay2}`}>•</span>
                                    <span className={`${styles.dealPendingDot} ${styles.delay3}`}>•</span>
                                </div>
                        }
                        
                    </div>

                    <div className={styles.stackDetailsWrapper}>
                        <img className={styles.stackIcon} src={gameAssets.dealStackIcon} />
                        <span style={{ color: "#bababa", fontSize: "12px" }}>
                            {parseDecimalValuesOfNumber(
                                    chipStack,
                                    2,
                                    false,
                                    checkToDisplayValueInL(chipStack),
                                    checkToDisplayValueInCr(chipStack)
                                )
                            }
                        </span>
                    </div>
                </div>
                <div className={styles.playerDataWrapper}>
                    <span style={{fontSize:'11px', color:"#bababa"}}>Winnings</span>
                    <span style={{ color: "#bababa", fontSize: "12px" }}>
                        {RUPEE_SYMBOL}
                        {parseDecimalValuesOfNumber(
                            actualPayout,
                            2,
                            false,
                            checkToDisplayValueInL(actualPayout),
                            checkToDisplayValueInCr(actualPayout)
                        )}
                    </span>
                </div>
                <div className={styles.playerDataWrapper}>
                    <span  style={{fontSize:'11px', color:"#bababa"}}>ICM Payout</span>
                    <span style={{ color: "#fffdea", fontSize: "12px" }}>
                        {RUPEE_SYMBOL}
                        {parseDecimalValuesOfNumber(
                            icmPayout,
                            2,
                            false,
                            checkToDisplayValueInL(icmPayout),
                            checkToDisplayValueInCr(icmPayout)
                        )}
                        {actualPayout < icmPayout ? <img className={styles.greenUpArrowIcon} src={gameAssets.greenUpArrow} alt="green-up-arrow" /> : ""}
                    </span>
                </div>
            </div>
        )
    }

  return (
        <div className={styles.icmPayoutContainer}>
            <div className={styles.icmHeaderWrapper}>
                <div className={styles.icmTitle}>
                    Deal Making
                </div>
                <div className={styles.icmTimerWrapper}>
                    {/* <BuyInTimer
                        // tempTableId={tempTableId}
                        // type={TIMER_TYPE_BUY_IN}
                        type={TIMER_TYPE_DEAL_MAKING}
                        timer={dealICMRunTime}
                        buyInCloseFunction={dealtimerEndCallBack}
                    /> */}
                    <div className={styles.icmTimerText}>{dealICMRunTime}</div>
                </div>
            </div>
            <div className={styles.icmDescriptionWrapper}>
                <li><div>All Players must accept for the deal to take place.</div></li>
            </div>
                <div className={styles.icmPayoutTableWrapper}>
                        {Object.entries(dealICMData).map(([playerName, playerDetails], index) => renderPlayerDetails(playerName, playerDetails, index))}
                </div>
                <div className={styles.icmFooterWrapper}>
                    {!dealICMVoted ?
                        <>
                            <button
                                className={`${styles.buttonwrapper} ${styles.rejectButton}`}
                                onClick={onRejectButtonClick}
                            >Reject</button>
                            <button
                                className={`${styles.buttonwrapper} ${styles.acceptButton}`}
                                onClick={onAcceptButtonClick}
                            >Accept</button>
                        </> :
                        <div className={styles.dealProgressText}>* Waiting for other players to take decision</div>
                    }
                </div>
        </div>
    );
}